// window.addEventListener('load', function() {
//   const scripts = document.getElementsByTagName('script');
//   for (let i = 0; i < scripts.length; i++) {
//     if (scripts[i].src === 'https://na.shgcdn3.com/collector.js?shop=cocacocajp.myshopify.com') {
//       scripts[i].parentNode.removeChild(scripts[i]);
//     }
//   }
// });
$(document).ready(function(){

  // sessionStorage.setItem('shown', true);
  // if (!sessionStorage.getItem('shown')){
  //     $('body').addClass('c-loading');
  // }


  // Hide Noshi 
  var checkNoshi = setInterval(function() {
    var $item = $('#line-item-property__field');
    if ($item.length) {
      clearInterval(checkNoshi);
      $('#line-item-property__field').remove();
    }
  }, 100); // check every 100ms
  // Hide Noshi 

  if($('.collection-top-bar__filters a').length >= 3){
    $('.collection-top-bar__filters').addClass('c-filter-flex-start');
  }

  if($('.template-article').length){
    var $count = $('.rte-table td img').length;
    var $img = $('.rte-table td img');
    var $tableHasImg = $img.parents('.rte-table');
    if($count >= 2){
      $tableHasImg.addClass('u-table-has-img');
    }
  }

  // Check apple device
  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
    $("body").addClass("u-mac");
  }

  _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
  if(_iOSDevice){
    $('.slider-dots-box button').addClass('ios');
  }
  // Check apple device

  //   menu top item 

  var $prevScrollpos = $(window).scrollTop();
  var $menuTopItem = $('.headerSP');
  $(window).scroll(function(){
    var $currentScrollpos = $(window).scrollTop();
    if($prevScrollpos > $currentScrollpos){
      $menuTopItem.addClass('c-header-show');
    }else{
      $menuTopItem.removeClass('c-header-show');
    }
    $prevScrollpos = $currentScrollpos;
  })

  //   menu top item 


  // if($(".template-index").length){

  $(".nav__item-parent .nav__link-parent").on("click",function(){
    if($(this).hasClass("nav__menu--active")){
      $(this).next().animate({
        "opacity": "1",
      },10,function(){

      });
    }else{
      $(this).next().animate({
        "opacity": "0",
      },300,function(){
        $(this).next().removeClass("visible");
      }.bind(this));
    }
  });

  $(".nav__item-parent").on("mouseenter",function(){
    $(this).find("a").addClass("nav__menu--active");
    $(this).find("a").attr("aria-expanded",true);
    $(this).addClass("is_active");
    $(".header-overlay").addClass("is-active");
    $(".header-overlay__inner").addClass("is-visible");
    $(".nav--depth-1").css({
      "overflow-x": "visible"
    });
    setTimeout(function() {
      $(this).find(".nav__submenu.nav__meganav, .nav__submenu").animate({
        "opacity": "1",
      },{
        duration: 10,
        start:function(){
          $(this).find(".nav__submenu.nav__meganav, .nav__submenu").addClass("visible");
        }.bind(this),
      });
    }.bind(this), 0);

  });
  $(".nav__item-parent").on("mouseleave",function(){
    $(this).find("a").removeClass("nav__menu--active");
    $(this).find("a").attr("aria-expanded",false);
    $(this).removeClass("is_active");
    $(".header-overlay").removeClass("is-active");
    $(".header-overlay__inner").removeClass("is-visible");
    $(".nav--depth-1").css({
      "overflow-x": "auto"
    });
    $(this).find(".nav__submenu.nav__meganav, .nav__submenu").animate({
      "opacity": "0",
    },300,function(){
      $(this).find("a").next().removeClass("visible");
    }.bind(this));
  });
  $(".nav__submenu").on("mouseenter",function(){
    $(this).prev().addClass("nav__menu--active");
    $(this).prev().attr("aria-expanded",true);
    $(this).parent().addClass("is_active");
    $(this).addClass("visible");
    $(".nav--depth-1").css({
      "overflow-x": "visible"
    });
    $(this).css({
      "opacity": "1",
    });
  });
  $(".nav__submenu").on("mouseleave",function(){
    $(this).prev().removeClass("nav__menu--active");
    $(this).prev().attr("aria-expanded",false);
    $(this).parent().removeClass("is_active");
    $(".header-overlay").removeClass("is-active");
    $(".header-overlay__inner").removeClass("is-visible");
    $(".nav--depth-1").css({
      "overflow-x": "auto"
    });
    $(this).animate({
      "opacity": "0",
    },300,function(){
      $(this).removeClass("visible");
    }.bind(this));
  });

  if($("fieldset").length){
    var span = document.createElement("span");
    $("fieldset").find("legend").hide();
    var text =  $("fieldset").find("legend").text();
    span.innerText = text;
    $("fieldset").prepend(span);
  }
  // }

  //End hover menu header



  // News slider
  var $slideshow = $('.c-new-slideshow__box');
  var $timelineBox = $('.c-new-slideshow__countBox');

  if ($slideshow.length) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = $('.c-new-slideshow__counter');

    var updateSliderCounter = function updateSliderCounter(slick, currentIndex) {
      currentSlide = slick.slickCurrentSlide() + 1;
      slidesCount = slick.slideCount;

      if (slidesCount <= 9) {
        // $(sliderCounter).text(currentSlide + '/' +slidesCount)
        $(sliderCounter).html("<span class='c-slideshow__current'>" + currentSlide + "</span><span class='c-slideshow__total'>" + slidesCount + "</span>");
      } else {
        // $(sliderCounter).text(currentSlide + '/' +slidesCount)
        $(sliderCounter).html("<span class='c-slideshow__current'>" + currentSlide + "</span><span class='c-slideshow__total'>" + slidesCount + "</span>");
      }
    };

    $slideshow.on('init', function (event, slick) {
      $timelineBox.append(sliderCounter);
      updateSliderCounter(slick);
    });

    $slideshow.on('afterChange', function (event, slick, currentSlide) {
      updateSliderCounter(slick, currentSlide);
    });

    $slideshow.slick({
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      dots: false,
      // fade: true,
      // cssEase: 'linear',
      // autoplay: true,
      // autoplaySpeed: 5000,
      // pauseOnFocus: false,
      // pauseOnHover: false,
      appendArrows: '.c-new-slideshow__arrow'
    });
  }
  // End News slider


  //image-slideshow

  $('.c-image-slideshow__box').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 2000,
    dots:false,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  //image-slideshow



  // Featured collection filter 
  
  //slider Gallery
  function newItemTop (){
    if($(window).width() > 768){
      $(".c-collection-filter__list").not(".slick-initialized").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots:false,
        infinite: true,
        swipeToSlide: true,
        arrows: false,
      });

    } else {
      $(".c-collection-filter__list").hasClass("slick-initialized") && $(".c-collection-filter__list").slick("unslick")
    }
  }

  newItemTop();
  $(window).on('resize', function(){
    newItemTop();
  });
  

  $(function() {

//    .slick({
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       dots:false,
//       infinite: true,
//       swipeToSlide: true,
//       arrows: false,
//       responsive: [
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 1,
//             arrows: true,
//             appendArrows: $('.c-collection-filter__arrow')
//           }
//         }
//       ]
//     });

//     $(".c-collection-filter__filter li").on('click', function(){
//       var filter = $(this).data('filter');
//       $(".c-collection-filter__filter li").removeClass('is-selected');
//       $(this).addClass('is-selected');
//       $(".c-collection-filter__list").slick('slickUnfilter');

//       if(filter == 'tops'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--tops');
//       }
//       else if(filter == 'pants'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--pants');
//       }
//       else if(filter == 'goods'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--goods');
//       }
//       else if(filter == 'outer'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--outer');
//       }
//       else if(filter == 'skirt'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--skirt');
//       }
//       else if(filter == 'onepiece'){
//         $(".c-collection-filter__list").slick('slickFilter','.c-collection-filter__item--onepiece');
//       }
//       else if(filter == 'all'){
//         $(".c-collection-filter__list").slick('slickUnfilter');
//       }

//     })

    $(".product-item__labelIem").each(function(){
      var foreignCharacters = $(this).text();
      var rforeign = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;

      if (rforeign.test(foreignCharacters)) {
        $(this).addClass('jpText');
      }
    })

  });

  // Featured collection filter 

//product detail slider reccomendation: YOU MAY ALSO LIKE 
  
 
  
  function recommendationsSlide (){
      
        var checkReccomendationSlide = setInterval(function() {
    var $item = $('.product-recommendations__products--list .product-recommendations__product');
    if ($item.length) {
      clearInterval(checkReccomendationSlide);
      
          if($(window).width() > 768){
			$('.product-recommendations__products--list').not(".slick-initialized").slick({
                arrows: false,
                infinite: false,	
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1
              });
    
          } else{
            $(".product-recommendations__products--list").hasClass("slick-initialized") && $(".product-recommendations__products--list").slick("unslick")
          }
    }
  }, 100); // check every 100ms
      
        
  }

  recommendationsSlide();
  $(window).on('resize', function(){
    recommendationsSlide();
  });

  var checkExistAwooRelatedProduct = setInterval(function() {
    var $item = $('.shopify-section--customRelatedProduct .related-wrapper');
    if ($item.length) {
      function showSliderRelatedProduct (){
        if($(window).width() >= 768){
          $('.related-product-list').not(".slick-initialized").slick({
            arrows: false,
            infinite: false,	
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1
          });
        
        } else{
          $(".related-product-list").hasClass("slick-initialized") && $(".related-product-list").slick("unslick")
        }
      }
    
      showSliderRelatedProduct();
      $(window).on('resize', function(){
        showSliderRelatedProduct();
      });
    }
  }, 500); // check every 100ms

  // Featured Collection 

  function productSlider(){
//     $('.c-sale .c-featured-collection__list').each(function(){
    $('.c-featured-collection__list').each(function(){
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots:false,
        infinite: true,
        arrows: false,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              arrows: true,
              appendArrows: $(this).parents('.c-featured-collection__main').find('.c-featured-collection__arrow')
            }
          }
        ]
      });
    });
  }
  productSlider();
  
  //slider restock top
  function restockTop (){
    if($(window).width() > 768){
      $('.c-restock-collection__list').not(".slick-initialized").slick({
        slidesToShow: 4,
    slidesToScroll: 1,
    dots:false,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
      });
    
    } else{
      $(".c-restock-collection__list").hasClass("slick-initialized") && $(".c-restock-collection__list").slick("unslick")
    }
  }

  restockTop();
  $(window).on('resize', function(){
    restockTop();
  });



//   $('.c-restock-collection__list').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots:false,
//     infinite: true,
//     swipeToSlide: true,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2,
//           arrows: true,
//           appendArrows: $('.c-restock-collection__arrow')
//         }
//       }
//     ]
//   });

  $('.c-instagram-live__list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots:false,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          appendArrows: $('.c-instagram-live__arrow')
        }
      }
    ]
  });

  if($('.c-ranking').length){
    $('.c-ranking').parents('.shopify-section--c-featured-collection').addClass('section-ranking');
  }
  if($('.c-sale').length){
    $('.c-sale').parents('.shopify-section--c-featured-collection').addClass('section-sale');
  }

//   var $slideNav = $('.c-featured-collection__list--ranking');
//   function playNav() {
//     var width = $(window).width();
//     if (width > 768) {
//       $slideNav.slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         dots:false,
//         infinite: true,
//         swipeToSlide: true,
//         arrows: false,
//       });
//     } else {
//       if ($slideNav.hasClass("slick-initialized")) {
//         $slideNav.slick("unslick");
//       }
//     }
//   }

//   $(window).on("resize orientationchange", function () {
//     playNav();
//   });
//   playNav();

  //End featured collection


  // Sticky Header 
  var $header = $('.header-container');
  var offset_sticky_header = $header.outerHeight();
  var offset_sticky_down = 0;

  jQuery(window).scroll(function() {  
    /* scroll header */
    if(jQuery(window).scrollTop() > offset_sticky_header && jQuery(window).scrollTop() > offset_sticky_down) {    
      if(jQuery(window).scrollTop() > offset_sticky_header){
        $header.removeClass('u-Sticky--up');
      }
    }
    else {
      if(jQuery(window).scrollTop() > offset_sticky_header) {
        $header.addClass('u-Sticky--up');  
      }
    }
    if (jQuery(window).scrollTop() <= offset_sticky_down && jQuery(window).scrollTop() <= offset_sticky_header ) {
      $header.removeClass('u-Sticky--up');
    }
    offset_sticky_down = jQuery(window).scrollTop();
   // console.log(offset_sticky_down);
  });

  $(window).scroll(function(){
    if($(window).width() > 768){
      if($(window).scrollTop() > 150){
        $header.addClass('u-sticky');
      }else{
        $header.removeClass('u-sticky');
      }

      if($(window).scrollTop() > 150){
        $header.addClass('u-sticky-down');	
      }else{
        $header.removeClass('u-sticky-down');
      }
    }else{
      if($(window).scrollTop() > 180){
        $header.addClass('u-sticky');
      }else{
        $header.removeClass('u-sticky');
      }

      if($(window).scrollTop() > 180){
        $header.addClass('u-sticky-down');	
      }else{
        $header.removeClass('u-sticky-down');
      }
    }

  })
  // // End Scroll Header Fix 


  //Drawer 

  $('.drawer-menu__linkToggle').on('click',function(e){
    e.preventDefault();
    $(this).next().slideToggle("slow");
    $(this).toggleClass("c-show");
  });

  $('.drawer-menu__itemChildButton').on('click',function(e){
    e.preventDefault();
    $(this).next().slideToggle("slow");
    $(this).toggleClass("c-show");
  });

  // End Drawer 

  // if($('.template-index').length){
  //   var checkLOKA = setInterval(function() {
  //     var $item = $('.widget .tile.tile-with-transition');
  //     if ($item.length) {
  //       clearInterval(checkLOKA);
  //       if($(window).width() <= 768){
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 250vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }else{
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 39.875vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }
  //     }
  //   }, 100); // check every 100ms

  //   $(window).resize(function(){
  //     if($(window).width() <= 768){
  //       $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 250vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //     }else{
  //       $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 39.875vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //     }
  //   })

  //   $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget .tile-list').click(function(){
  //     setTimeout(function(){
  //       if($(window).width() <= 768){
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 250vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }else{
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 39.875vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }
  //       $('.lightbox-close-button').addClass('c-close-icon-loka');
  //     },200)
  //   })

  //   $('.c-close-icon-loka').click(function(){
  //     setTimeout(function(){
  //       if($(window).width() <= 768){
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 250vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }else{
  //         $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'height: 39.875vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
  //       }
  //       $('.lightbox-close-button').addClass('c-close-icon-loka');
  //     },2000)
  //   })
  // }

  if($('.template-article').length){
    var checkLOKAArticle = setInterval(function() {
      var $item = $('.widget .tile.tile-with-transition');
      if ($item.length) {
        clearInterval(checkLOKAArticle);
        $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').addClass('c-overflow');
        if($(window).width() <= 768){
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 495vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }else{
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 319.5vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }
      }
    }, 100); // check every 100ms

    $(window).resize(function(){
      if($(window).width() <= 768){
        $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 495vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
      }else{
        $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 319.5vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
      }
    })

    $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget .tile-list').click(function(){
      setTimeout(function(){
        if($(window).width() <= 768){
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 495vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }else{
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 319.5vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }
        $('.lightbox-close-button').addClass('c-close-icon-loka');
      },200)
    })

    $('.c-close-icon-loka').click(function(){
      setTimeout(function(){
        if($(window).width() <= 768){
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 495vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }else{
          $('div#loka-story-widget-here .widget.loka-story-widget.grid-widget').attr('style', 'max-height: 319.5vw !important; display: block !important; width: 100% !important; background-color: rgb(255, 255, 255); z-index: 10000; overflow: hidden !important;');
        }
        $('.lightbox-close-button').addClass('c-close-icon-loka');
      },2000)
    })
  }

  if($('.jsShowCategory').length){
    $('.jsShowCategory').click(function(e){
      var href = $(this).attr('href');
      var hrefTitle = window.location.pathname;
      window.location = href;
      if(href = hrefTitle){
        $(this).parent().addClass('active')
      }
    })
  }

  // Body HTML toggle product page

  $('.product__descriptionTitle, .product__primeReviewsTitle').on('click',function(e){
    e.preventDefault();
    $(this).next().slideToggle("slow");
    $(this).toggleClass("c-show");
  });

  // Body HTML toggle product page

  window.onload = function() {
    function foo() {
      $('.shopify-payment-button__button--unbranded').text('今すぐ購入する');
    }
    setInterval(foo, 100);
    $('body').addClass('loaded');
  }

  // var carousel = $('.product__media').flickity();
  // var flkty = carousel.data('flickity');  
  // carousel.flickity( 'select', 4 );
  // console.log(flkty);
  // console.log(carousel);


  // Wishlist Recommended Product 

  var checkRecommendProduct = setInterval(function() {
    var $item = $('.product-recommendations__product');
    if ($item.length) {
      clearInterval(checkRecommendProduct);

      // window._swat.fetch( function(r) {
      //     console.log(r);
      // });

      $('.c-btn-wishlist').click(function(){
        var $dataAction = $(this).data('action');
        var $dataEmpi = $(this).data('empi');
        var $dataEpi = $(this).data('epi');
        var $dataDu = $(this).data('du');
        var $dataIu = $(this).data('iu');
        var $dataPr = $(this).data('pr');
        var $btn = $(this);
        if($dataAction == 'add'){
          window._swat.addToWishList(
            {
              "epi": $dataEpi,
              "du": $dataDu,
              "empi": $dataEmpi,
              "iu" : $dataIu,
              "pr": $dataPr
            },
            function(r) {
              console.log('Added to wishlist');
              $btn.data('action','remove');
            }
          );
        }else if($dataAction == 'remove'){
          window._swat.removeFromWishList(
            {
              "epi": $dataEpi,
              "du": $dataDu,
              "empi": $dataEmpi,
              "iu" : $dataIu,
              "pr": $dataPr
            },
            function(r) {
              console.log('Removed to wishlist');
              $btn.data('action','add');
            }
          );
        }

      }) 

    }
  }, 100); // check every 100ms

  // Wishlist Recommended Product 

  // let timeout;

  // function myFunction() {
  //   timeout = setTimeout(showTitleAwoo, 5000);
  // }
  // myFunction();
  // function showTitleAwoo() {
  //   if($('#awoo-product-tags .awoo-tag-wrapper .awoo-tag').length){
  //     $('.awoo-title-ct').show();
  //   }else{
  //     $('.awoo-title-ct').hide();
  //   }
  // }

  // if($('#awoo-product-tags .awoo-tag-wrapper').length){
  //   $(this).after('<span>人気カテゴリ</span>'); 
  // }

  // Button BIS 


  if($('.product-form__cart-submit').prop('disabled')){
    $('.product__backInStock').show();
  }else{
    $('.product__backInStock').hide();
  }

  var $variantSKU = $('#variant-selector').find(':selected').val();
  $('#BIS_trigger').attr('data-variant-id', $variantSKU);

  $('.product-form__option button').click(function(){
    var $variantSKU = $('#variant-selector').find(':selected').val();
    $('#BIS_trigger').attr('data-variant-id', $variantSKU);

    if($('.product-form__cart-submit').prop('disabled')){
      $('.product__backInStock').show();
    }else{
      $('.product__backInStock').hide();
    }

    if($('s[data-compare-price]').text() != ''){
      $('s[data-compare-price]').append('<span class="c-tax">円 (税込)</span>');
      $('.product__price').addClass('product__price--sale');
    }else{

      $('s[data-compare-price]').html();
      $('s[data-compare-price] .c-tax').remove();
      $('.product__price').removeClass('product__price--sale');
    }

  })

  $('.product__backInStockBIS').click(function(){
    $('#BIS_trigger').trigger('click');
  })

  // Button BIS 


  //Get variant quantity

  var variantQuantity = $('#variant-selector').find(':selected').data('quantity');
  $('.product-form__inventoryQuantity').html(variantQuantity);
  if(variantQuantity > 0){
    $('.product-form__inventoryQuantity').html('◯');
  }else{
    $('.product-form__inventoryQuantity').html('✕');
  }

  $('.product-form__option button').click(function(){
    // var url_string = window.location.href; //window.location.href
    // var url = new URL(url_string);
    // var variantID = url.searchParams.get("variant");
    var variantQuantity = $('#variant-selector').find(':selected').data('quantity');

    if(variantQuantity > 0){
      $('.product-form__inventoryQuantity').html('◯');
    }else{
      $('.product-form__inventoryQuantity').html('✕');
    }
  })
  //Get variant quantity

  // LINE Wazzup

//     var $variantSKU = $('#variant-selector').find(':selected').data('variantsku');
//   	$variantSKUIndex = $variantSKU.lastIndexOf("-") + 3;
//   	$variantSKU = $variantSKU.slice(0, $variantSKUIndex);
//     console.log($variantSKU);
  $('.product__backInStockBoxLine').click(function(){
    var $productID = $('#variant-selector').find(':selected').data('productid');
    var $variantSKU = $('#variant-selector').find(':selected').data('variantsku');
  	var $variantSKUIndex = $variantSKU.lastIndexOf("-") + 3;
  	var $variantSKUFinal = $variantSKU.slice(0, $variantSKUIndex);
    var $productSize = $('.product-form__chip-selected').text().slice(1, -1);
    var $productColor = $('.product-form__color-swatches-selected').text().slice(1, -1);
//     WazzUp.rearrival('16-210311201-02', $productColor, $productSize);
    WazzUp.rearrival($variantSKUFinal, $productColor, $productSize);
  })

  // LINE Wazzup


  // Remove Currency product page 
  // $('.product-form__option button').click(function(){
  //   $('span[data-product-price]').each(function(){
  //     var $textCurrency = $(this).text();
  //     var $textWithoutCurrency = $textCurrency.substring(1);
  //     $(this).html($textWithoutCurrency);
  //   })
  // })
  // Remove Currency product page 


  // dragList 

  window.dragList = function(element){
    var clicked = false, clickX;
    var ele = $(element);
    var start = ele.scrollLeft();
    ele.on({
      'mousemove': function(e) {
        clicked && updateScrollPos(e);
      },
      'mousedown': function(e) {
        clicked = true;
        clickX = e.clientX;
        start = ele.scrollLeft();
      },
      'mouseup': function(e) {
        clicked = false;
        ele.css('cursor', 'grab');
      }
    });

    var updateScrollPos = function(e) {
      ele.css('cursor', 'grabbing');
      ele.scrollLeft(start + (clickX - e.clientX));
    }
    }

  dragList('.product-thumbnails');

  // dragList 



  // Drawer Menu 

  // $('.mobile-nav__trigger, .quick-cart__trigger').click(function(){
  //   setTimeout(function(){
  //     $('body').attr('style', 'overflow: hidden !important;');
  //   },100)
  // })

  $('.drawer-menu__close, li.quick-cart__close.js-close').click(function(){
    setTimeout(function(){
      $('body').attr('style', 'overflow: visible !important;');
    },100)
  })

  $('.drawer-overlay__inner.is-visible').click(function(){
    $('li.quick-cart__close.js-close').click();
  })

  $('.drawer-menu__overlay').click(function(){

    $('body').attr('style', 'overflow: visible !important;');
  })
  // Drawer Menu 

  $('.reviews-flyout__header a').click(function(){
    $('.drawer-overlay__inner').click();
  })



  $('.filter-item a.filter-item__content').click(function(){
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  })

  // function staffStartMobile(){

  //   //slick slider staffstart app product detail mobile
  //   var spScreen = window.matchMedia('(max-width: 959px)');
  //   var checkStaffStartApp = setInterval(function() {

  //     var $item = $('.fsfWuT');

  //     if ($item.length) {
  //       clearInterval(checkStaffStartApp);
  //       if (spScreen.matches) {

  //         $item.slick({
  //           infinite: true,
  //           slidesToShow: 3,
  //           slidesToScroll: 1,
  //           arrows: true,
  //         });
  //       } else{
  //         $item.hasClass("slick-slider") && $item.slick("unslick");
  //       }
  //     }

  //   }, 100); // check every 100ms
  // }
  // staffStartMobile();

  // $( window ).resize(function() {
  //   staffStartMobile();
  // });

  //     var spScreen = window.matchMedia('(max-width: 959px)');
  //   if (spScreen.matches) {
  //      setInterval(function (){
  //      $('.fsfWuT').slick({
  //         infinite: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //     });
  //     }, 5000)
  //   }


  // Hide Styling
  // var checkStyling = setInterval(function() {
  //   var $item = $('.staffstart-shopify-app-container.product article');
  //   if ($item.length) {
  //     clearInterval(checkStyling);
  //     $('.GkeGT').addClass('c-border-top');
  //   }
  // }, 100); 
  // check every 100ms
  // Hide Styling
  
    
})



function productSlidePc(){
  //slick slider product detail pc
  var pcScreen = window.matchMedia('(min-width: 960px)');
  var $slickParent = $('.template-product .product__media');

  if (pcScreen.matches && !$slickParent.hasClass("flickity-enabled")) {
    $slickParent.not(".slick-initialized").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      infinite: true,
      dots: true,
      customPaging: function(slider, i) { 
        return '<button class="dots-nav__item" data-media-id="'+$(slider.$slides[i]).find('.media-wrapper').data('media-id')+'"><span style="background-image:url('+$(slider.$slides[i]).find('.media-wrapper').data('thumb')+');"></span></button>';
      }
    });
    var $heightSlickDots = $('.template-product .product__media .slick-dots').height();
    $('.template-product .product__mediaBox').css('--dots-height', $heightSlickDots)
  } else{
    $slickParent.hasClass("slick-slider") && $slickParent.slick("unslick");
    $('.template-product .product-thumbnails__list').hasClass("slick-slider") && $('.template-product .product-thumbnails__list').slick("unslick");
    var checkFlickityDots = setInterval(function() {
      var $item = $('.product__media .flickity-page-dots');
      if ($item.length) {
        clearInterval(checkFlickityDots);
        var $heightSlickDots = $('.template-product .product__media .flickity-page-dots').height();
        $('.template-product .product__mediaBox').css('--dots-height', $heightSlickDots)
      }
    }, 100); // check every 100ms
  }
}

productSlidePc();

$( window ).resize(function() {
  productSlidePc();
});

var checkFlickityDot = setInterval(function() {
  var $item = $('.product__mediaBox .flickity-page-dots');
  if ($item.length) {
    clearInterval(checkFlickityDot);
    $('.product__mediaBox .flickity-page-dots li').each(function(){
      var _this = $(this);
      var val_i = _this.attr('aria-label');

      $('.product__mediaBox .flickity-page-dots-customs li').each(function(){
        var _this2 = $(this);
        var val_i2 = _this2.attr('aria-label');
        var val_i2_media_id = _this2.data('media-id');
        var img_dots = _this2.html();
        if(val_i == val_i2){
          _this.append(img_dots)
          _this.attr('data-media-id', val_i2_media_id)
        }
      })
    })
  }
}, 100); // check every 100ms



// sticky filter collection mobile

// $(function() {
//   var filter = $(".collection-top-bar__filters");
  

//   $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();
//     if (scroll >= 500) {
//       filter.addClass("filter-scrolled");
//     } else {
//       filter.removeClass("filter-scrolled");
//     }
    
//     var checkHeaderSP = $('.headerSP.c-header-show');
//   	var filterScrolled = $('.filter-scrolled');
    
//     if(checkHeaderSP.length){
//       filterScrolled.addClass('move-down');
//     }else{
//       filterScrolled.removeClass('move-down');
//     }
//   });

// });
$(document).ready(function(){
// changed instagram app position in product detail
  if($('.template-product').length){
    $('#widget_app_insta').append($('#loka-story-widget-here'));
    $('#widget_app_insta').append($('a[target="_top"]'));
    //     $('.product__description').append($('.staffstart-shopify-app-container.product'));
   $('#primeReviews').append($('.mxpr-block-product-review'));
    
    // $('#mxpr-form-submit-button').click(function(){
    //   $('html').addClass('no-scroll');
    // })
    $('.mxpr-modal-thankyou-ok, .mxpr-modal__overlay').click(function(){
       $('html').removeClass('no-scroll');
    })
    $('.product__headerRating').click(function(){
      $('html, body').animate({
        scrollTop: $(".product__primeReviews").offset().top - 60
      }, 500);
    })
  }

  // show popup  
  var popupitem = $("#shopify-section-exit-intent--news .exit-intent--news");
  var closepopup = $("#shopify-section-exit-intent--news .exit-intent__close");
  $("#shopify-section-announcement-bar .announcement-bar__content span").click(function () {
    if(popupitem.hasClass("visible")){
      popupitem.removeClass("visible");
       popupitem.removeClass("animating");
    }else{
      popupitem.addClass("visible");
      popupitem.addClass("animating");
    }
  });
  closepopup.click(function () {
    popupitem.removeClass("visible");
    $('body').css('overflow','visible');
  });
  $(".c-mail__magazine").click(function () {
    if(popupitem.hasClass("visible")){
      popupitem.removeClass("visible");
       popupitem.removeClass("animating");
    }else{
      popupitem.addClass("visible");
      popupitem.addClass("animating");
    }
    $(".drawer-menu").removeClass("active");
    $(".drawer-menu").removeClass("visible");
    $('body').css('overflow','visible');
  });
  if(location.href.indexOf('?customer_posted=true') > 1){
    popupitem.addClass("visible");
    popupitem.addClass("animating");
  }

  // slick show thumbnail
   if ($('.js-clickShowThumbnail').length > 0) {
     $('.js-clickShowThumbnail').click(function () {
       const idThumbnail = $(this).data('media-id');
       if (idThumbnail) {
         // $('.product__media .dots-nav__item[data-media-id='+idThumbnail+']').click();

         $('.product__media .dots-nav__item[data-media-id='+idThumbnail+']').on('click', function(event) {
          $(this).get(0).focus({ preventScroll: true });
         }).click(); 
       
       //on mobile
        var checkFlickityDotSP = setInterval(function() {
          var $item = $('.product__mediaBox .flickity-page-dots');
          if ($item.length) {
            clearInterval(checkFlickityDotSP);
            $('.flickity-page-dots .dot[data-media-id='+idThumbnail+']').click();
          }
        }, 100); // check every 100ms
       }
       
     })
   }
});



// 商品カードのスライド
function initProductItemSwiper(el) {
  new Swiper(el, {
    spaceBetween: 1,
    loop: false,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
  });

  // 矢印・ページネーションは商品リンク(<a>)の中に入れ子になっているため、
  // クリックが親要素まで伝播すると商品ページへ遷移してしまう。
  el.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination').forEach(function (control) {
    control.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // PC幅では「おすすめ商品」「関連商品」リスト全体がSlickカルーセルになっており、
  // その中に本Swiperが入れ子になっている。ドラッグ操作が外側のSlickに伝播しないよう止める。
  ['touchstart', 'mousedown'].forEach(function (eventName) {
    el.addEventListener(eventName, function (e) {
      e.stopPropagation();
    }, { passive: true });
  });
}

// 画面内に入ったカードだけ初期化する(画面外の分は初期化コストをかけない)
var swiperObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      initProductItemSwiper(entry.target);
      swiperObserver.unobserve(entry.target);
    }
  });
}, { rootMargin: '200px' });

document.querySelectorAll('.product-item__swiper').forEach(function (el) {
  swiperObserver.observe(el);
});